export default __webpack_public_path__ + "locales/it/ChangePortalOwner.json?hash=a513c4554f5ba5cb63085baafb46df29";